import { CustomAction } from '@mtm/conversation-ui-angular';
import { ArrowPointIconComponent } from '../../project-subsection/svg/arrow-point-icon/arrow-point-icon.component';
import { HighlightIconComponent } from '../../project-subsection/svg/highlight-icon/highlight-icon.component';
import { RectIconComponent } from '../../project-subsection/svg/rect-icon/rect-icon.component';
import { ArrowDrawingIconComponent } from '../../project-subsection/svg/arrow-drawing-icon/arrow-drawing-icon.component';
import { SeparatorIconComponent } from '../../project-subsection/svg/separator-icon/separator-icon.component';
import { YellowCircleIconComponent } from '../../project-subsection/svg/yellow-circle-icon/yellow-circle-icon.component';
import { PurpleCircleIconComponent } from '../../project-subsection/svg/purple-circle-icon/purple-circle-icon.component';
import { OrangeCircleIconComponent } from '../../project-subsection/svg/orange-circle-icon/orange-circle-icon.component';
import { RedCircleIconComponent } from '../../project-subsection/svg/red-circle-icon/red-circle-icon.component';
import { BlueCircleIconComponent } from '../../project-subsection/svg/blue-circle-icon/blue-circle-icon.component';
import { UndoIconComponent } from '../../project-subsection/svg/undo-icon/undo-icon.component';
import { GreenCircleIconComponent } from '../../project-subsection/svg/green-circle-icon/green-circle-icon.component';
import { RedoIconComponent } from '../../project-subsection/svg/redo-icon/redo-icon.component';
import { DeleteIconComponent } from '../../project-subsection/svg/delete-icon/delete-icon.component';
import { CircleIconComponent } from '../../project-subsection/svg/circle-icon/circle-icon.component';

export const DRAWING_TOOLS: CustomAction[] = [
  {
    icon: ArrowPointIconComponent,
    tooltip: 'Cursor',
    name: 'cursor',
    type: 'tool',
  },
  {
    icon: HighlightIconComponent,
    tooltip: 'Draw',
    name: 'pencil',
    type: 'tool',
  },
  {
    icon: CircleIconComponent,
    tooltip: 'Circle',
    name: 'circle',
    type: 'tool',
  },
  {
    icon: RectIconComponent,
    tooltip: 'Rectangle',
    name: 'rectangle',
    type: 'tool',
  },
  {
    icon: ArrowDrawingIconComponent,
    tooltip: 'Line',
    name: 'arrow',
    type: 'tool',
  },
  // {
  //   icon: SeparatorIconComponent,
  //   tooltip: '',
  //   name: 'separator',
  //   type: 'decorator',
  // },
  {
    icon: RedCircleIconComponent,
    tooltip: 'Red',
    name: 'red',
    value: '#FF2E1E',
    type: 'color',
  },
  {
    icon: PurpleCircleIconComponent,
    tooltip: 'Purple',
    name: 'purple',
    value: '#BE2BD7',
    type: 'color',
  },
  {
    icon: BlueCircleIconComponent,
    tooltip: 'Blue',
    name: 'blue',
    value: '#27CBFF',
    type: 'color',
  },
  {
    icon: GreenCircleIconComponent,
    tooltip: 'Green',
    name: 'green',
    value: '#47FF5A',
    type: 'color',
  },
  {
    icon: YellowCircleIconComponent,
    tooltip: 'Yellow',
    name: 'yellow',
    value: '#FFF735',
    type: 'color',
  },
  {
    icon: OrangeCircleIconComponent,
    tooltip: 'Orange',
    name: 'orange',
    value: '#FF9800',
    type: 'color',
  },
  {
    icon: UndoIconComponent,
    tooltip: 'Undo',
    name: 'undo',
    type: 'action',
  },
  {
    icon: RedoIconComponent,
    tooltip: 'Redo',
    name: 'redo',
    type: 'action',
  },
  {
    icon: DeleteIconComponent,
    tooltip: 'Delete',
    name: 'clear',
    type: 'action',
  },
];
